import { useCallback } from 'react';

import { useDoBoxExecutorFlags } from './useDoBoxExecutorFlags';
import { useAgentSetupPanelStore } from '../../store/AgentSetupPanel';

export interface StartAgentSetupParams {
  itemId: string;
  taskGroupId: string;
}

export interface StartAgentSetupForEntryResult {
  canStartAgentSetup: boolean;
  startAgentSetup: (params: StartAgentSetupParams) => void;
}

/** Re-entering would recreate the draft and wipe a setup already in progress on the item. */
export function startAgentSetupForEntry(params: StartAgentSetupParams): void {
  const { phaseByItemId, enterAgentSetup } = useAgentSetupPanelStore.getState();
  if (phaseByItemId[params.itemId] !== undefined) {
    return;
  }
  enterAgentSetup({ itemId: params.itemId, taskGroupId: params.taskGroupId });
}

/** Mounts the executor flags query (cache-and-network): never call it once per list card. */
export function useStartAgentSetupForEntry(): StartAgentSetupForEntryResult {
  const { flags } = useDoBoxExecutorFlags();
  const startAgentSetup = useCallback(
    (params: StartAgentSetupParams) => startAgentSetupForEntry(params),
    [],
  );

  return {
    canStartAgentSetup: flags.executor && flags.agentSetup,
    startAgentSetup,
  };
}
